<template>
  <section class="interests">
    <div class="title">
      <em :class="spriteCalss('title-icon-left')" />
      {{ title }}
      <em :class="spriteCalss('title-icon-right')" />
    </div>
    <ul>
      <li
        v-for="(item, index) in iconList"
        :key="index"
      >
        <i :class="spriteCalss(item.className)" />
        <span
          class="icon-title"
          v-html="item.title"
        />
      </li>
    </ul>
  </section>
</template>

<script>
import { classes } from '@/utils/util'
const spriteCalss = classes('sprite-official-accounts-pay')

export default {
  name: 'WeChatInterests',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    iconListKey: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      iconListMap: {
        duba: [
          { className: 'data-recovery', title: '数据恢复' },
          { className: 'folder-encryption', title: '文件夹加密' },
          { className: 'doc-burner', title: '文件粉碎' },
          { className: 'c-drive-slimming', title: 'C盘瘦身专家' },
          { className: 'browser-homepage-repair', title: '浏览器主页修复' },
          { className: 'document-repair', title: '文档修复' },
          { className: 'document-guard', title: '文档卫士' }
        ],
        pdf: [
          { className: 'pdf-to-word', title: 'PDF转Word' },
          { className: 'pdf-edit', title: 'PDF编辑' },
          { className: 'pdf-to-img', title: 'PDF转图片' },
          { className: 'ocr-recognizes-text', title: 'OCR文字识别' },
          { className: 'pdf-merge', title: 'PDF合并' },
          { className: 'pdf-extract', title: 'PDF页面提取' },
          { className: 'pdf-split', title: 'PDF拆分' },
          { className: 'cad-change', title: 'CAD转换' },
          { className: 'pdf-label', title: 'PDF标注' },
          { className: 'ppt-to-pdf', title: 'PPT转PDF' },
          { className: 'excel-to-pdf', title: 'Excel转PDF' },
          { className: 'pdf-compress', title: 'PDF压缩' },
        ]
      }
    }
  },
  computed: {
    iconList () {
      return this.iconListKey.reduce((arr, key) => {
        if (this.iconListMap[key]) {
          arr = arr.concat(this.iconListMap[key])
        }
        return arr
      }, [])
    }
  },

  methods: {
    spriteCalss
  },
}
</script>

<style scoped lang="scss">
@import '~@/assets/css/sprite-official-accounts-pay.scss';
  .interests {
    text-align: center;
    height: 100%;
    overflow: auto;
    padding: 0 40px 40px 40px;
    background: #fff;
    margin-bottom: 20px;
    .title {
      font-size: 32px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 50px;
      margin-top: 24px;
    }
    ul {
      display: grid;
      justify-content: space-between;
      grid-template-columns: repeat(auto-fill, 152px);
      grid-gap: 20px;
      li {
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        width: 152px;
        height: 152px;
        background: #fefbeb;
        border: 1px solid #f7d65c;
        border-radius: 4px;
        .icon-title {
          margin-top:10px;
          margin-bottom:16px;
          font-size: 20px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
</style>
